<template>
  <div class="schedule-stats">
    <div class="sw-chip-group">
      <span class="sw-chip">{{ stats.total }} agendamentos</span>
      <span class="sw-chip">{{ stats.waiting }} na espera</span>
      <span class="sw-chip">{{ stats.inCare }} em atendimento</span>
      <span class="sw-chip">{{ stats.next }} a chegar</span>
    </div>
    <button
      type="button"
      class="sw-chip sw-chip--primary"
      title="Lista de pacientes"
      @click="$emit('download')"
    >
      <i class="bi bi-download"></i>
      Baixar
    </button>
  </div>
</template>

<script>
export default {
  name: 'ScheduleStatsBar',
  props: {
    stats: {
      type: Object,
      default: () => ({ total: 0, waiting: 0, inCare: 0, next: 0 }),
    },
  },
  emits: ['download'],
};
</script>

<style scoped>
.schedule-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.85rem;
}
.schedule-stats .sw-chip-group {
  flex: 1;
  min-width: 0;
}
.schedule-stats .sw-chip {
  min-height: 2.25rem;
  padding: 0.4rem 0.8rem;
  font-size: 0.86rem;
}
.schedule-stats .sw-chip--primary {
  margin-left: auto;
  padding: 0.45rem 0.95rem;
  min-height: 2.35rem;
  font-size: 0.875rem;
}
.schedule-stats .sw-chip--primary:hover {
  color: #fff;
}
.schedule-stats .sw-chip--primary i {
  font-size: 1rem;
}
</style>
